import { GridLogicOperator } from '@mui/x-data-grid-pro';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';

export const getUsersGridInitialState = (): GridInitialStatePro => {
  return {
    filter: {
      filterModel: {
        items: [],
        quickFilterLogicOperator: GridLogicOperator.Or,
      },
    },
    sorting: {
      sortModel: [
        {
          field: 'role',
          sort: 'asc',
        },
      ],
    },
  };
};
